import React, { useEffect } from 'react'
import { Grid } from "@mui/material"

import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import { alertsSection, isMinMaxPriceTabLoading, isMinMaxPriceTabEmpty } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"
import { BACKEND_APIS } from "@constants"
import { offices, reports } from "@signals"
import { setLastOfficeSubmitted } from "Pages/ReportsAlerts/Alerts/Notifications/@signals"
import { comparatorColumn, diffColumn, lorColumn, pickupDateColumn, siteColumn } from "Pages/ReportsAlerts/Alerts/Notifications/@components"
import { conditionNameColumn } from "Pages/ReportsAlerts/Alerts/Notifications/MinMax/columns"
import { batch } from "@preact/signals-react"
import { isTourDemoActive } from "@signals/app"
import { dsColorNew } from "@palette"


export default function MinMaxBlock() {

	const { getTableData, tableData, isTableLoading, filterConditions } = useAlertsTableData(`${BACKEND_APIS.NOTIFICATIONS}/min-max`)

	useEffect(() => {
		if (!!offices.value && !!reports.value) {
			isMinMaxPriceTabLoading.value = true
			isMinMaxPriceTabEmpty.value = false
			getTableData({ idReportExecution: reports.value, idOfficePickup: offices.value })
				.then(data => { isMinMaxPriceTabEmpty.value = !data?.length })
				.finally(() => batch(() => {
					isMinMaxPriceTabLoading.value = false
					setLastOfficeSubmitted()
				}))
		}
	}, [reports.value, offices.value])

	if (alertsSection.value !== ALERTS.MIN_MAX_PRICE) return <></>
	if (isTourDemoActive.value && !tableData?.length) return <></>

	return <Grid item xs={12}>
		<AlertsBaseTable
			title="Notifications: Min & Max Prices"
			data={tableData}
			isLoading={isTableLoading}
			filterConditions={filterConditions}
			columns={[
				conditionNameColumn(),
				pickupDateColumn(),
				lorColumn(),
				...comparatorColumn("category", "Category"),
				...comparatorColumn("acriss", "Acriss"),
				...comparatorColumn("fuelPolicy", "Fuel Policy"),
				...comparatorColumn("transmission", "Transmission"),
				...comparatorColumn("mileage", "Mileage"),
				...comparatorColumn("terminal", "Vendor Airport Location"),
				...comparatorColumn("insurance", "Insurance"),
				...comparatorColumn("carDescription", "Car Description"),
				...siteColumn(),
				...comparatorColumn("provider", "Provider"),
				...comparatorColumn("price", "Price", true),
				...comparatorColumn("currency", "Currency", true),
				diffColumn()
			]}
			legend={[
				{ icon: "percent", value: "%", label: "Percentage" },
				{ icon: "money-bills", value: "$", label: "Currency", iconProps: { color: dsColorNew.successText } },
				{ icon: "gem", value: "Most expensive", label: "Most Expensive", iconProps: { color: "colors.purple" } },
				{ icon: "coins", value: "Cheapest", label: "Cheapest", iconProps: { color: dsColorNew.noteAmber } },
				{ icon: "arrow-up", value: "Higher than", label: "Higher Than", iconProps: { color: dsColorNew.successText } },
				{ icon: "arrow-down", value: "Lower than", label: "Lower Than", iconProps: { color: dsColorNew.dangerRed } },
			]}
		/>
	</Grid>
}